'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/millisecondAfter.js
// module id = 344
// module chunks = 1